import cs from 'classnames';
import Link from 'next/link';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import type { IButtonColorType } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import { MONTH_PERSIAN } from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageTabInner';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import SubscriptionDescription from '../SubscriptionDescription/SubscriptionDescription';
interface SubscriptionBuyPlanProps {
  plan: ISubscriptionPlan;
}
interface IResultTitle {
  title: string;
  subtitle: string;
}
const BUTTON_COLOR: Record<string, IButtonColorType> = {
  green: 'green',
  blue: 'primary',
  orange: 'orange',
  pink: 'pink'
};
const TITLE_COLOR: Record<string, string> = {
  green: 'text-greenSix',
  blue: 'text-blueSix',
  orange: 'text-orangeSix',
  pink: ' text-pinkSix'
};
const TITLE_SHADOW: Record<string, string> = {
  green: 'drop-shadow-lightGreen',
  blue: 'drop-shadow-lightBlue',
  orange: 'drop-shadow-lightOrange',
  pink: ' drop-shadow-lightPink'
};
const SubscriptionBuyPlan: FC<SubscriptionBuyPlanProps> = ({
  plan
}) => {
  const resultTitle: IResultTitle = useMemo(() => {
    return {
      title: plan.subscriptionName.split('_')[0],
      subtitle: plan.subscriptionName.split('_')[1]
    };
  }, [plan]);
  return <div className={cs(`border-${plan.color}Six border-[2px] p-6 flex flex-col sm:flex-row justify-around items-center mb-4`)} data-sentry-component="SubscriptionBuyPlan" data-sentry-source-file="SubscriptionBuyPlan.tsx">
      <div>
        <div className={cs(`text-center text-3xl font-extrabold mb-2 ${TITLE_COLOR[plan.color]} ${TITLE_SHADOW[plan.color]}`)}>
          {resultTitle.title}
        </div>
        <div className={cs(`${TITLE_SHADOW[plan.color]} mb-2 text-lg font-bold text-blackSeven`)}>
          {resultTitle.subtitle}
        </div>
        <div className={cs(`${TITLE_SHADOW[plan.color]} flex flex-row justify-center text-xl font-bold text-blackSeven text-center`)}>
          <div className="pl-2">{plan.price.price.toLocaleString()} </div>/
          <div className="pr-2"> {MONTH_PERSIAN[plan.duration!]}</div>
        </div>
      </div>
      <div className="my-4 flex flex-wrap sm:flex-col ">
        <SubscriptionDescription subscriptionDescription={plan.subscriptionDescription} data-sentry-element="SubscriptionDescription" data-sentry-source-file="SubscriptionBuyPlan.tsx" />
      </div>
      <Button href={LINKS.SUBSCRIPTION.MAIN} as={Link} radius="circle" className=" my-4 font-bold" color={BUTTON_COLOR[plan.color] ?? 'primary'} variant="shadow" data-sentry-element="Button" data-sentry-source-file="SubscriptionBuyPlan.tsx">
        تغییر اشتراک
      </Button>
    </div>;
};
export default SubscriptionBuyPlan;